define('modules/form/form_item_view',[
  'backbone',
  'jquery',
  '_'

], function (Backbone, $, _) {
  'use strict';
  var FormItem = Backbone.View.extend({
    initialize: function (options) {
      _.extend(this, options);
      var name = {};
      name[this.model.get('name')] = '';
      this.dataModel = this.dataModel || new Backbone.Model(name);

      if (this.model.get('error')) {
        this.$el.addClass('form-item--error');
      }

    },

    tagName: 'div',
    className: function () {
      var formItemClassName = 'form-item ' + this.model.get('name');
      if (this.model.get('readonly'))
      {
        formItemClassName += ' read-only';
      }

      return formItemClassName;
    }

  });
  return FormItem;
});

